import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "./Button";

export const CopyButton: React.FC<{
  value: string;
  label?: string;
  copiedLabel?: string;
  variant?: "accent" | "secondary" | "ghost" | "warn";
  size?: "md" | "sm" | "xs";
  className?: string;
}> = ({
  value,
  label = "Copy",
  copiedLabel = "Copied",
  variant = "secondary",
  size = "sm",
  className = ""
}) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };

  return (
    <Button
      variant={copied ? "accent" : variant}
      size={size}
      className={className}
      leftIcon={copied ? <Check size={16} /> : <Copy size={16} />}
      onClick={copy}
    >
      {copied ? copiedLabel : label}
    </Button>
  );
};

export const IconCopyButton: React.FC<{ value: string; className?: string }> = ({
  value,
  className = ""
}) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };
  return (
    <button
      type="button"
      title={copied ? "Copied" : "Copy"}
      className={`rounded-md p-1.5 text-muted hover:bg-border/60 hover:text-ink ${className}`}
      onClick={copy}
    >
      {copied ? <Check size={16} /> : <Copy size={16} />}
    </button>
  );
};
